import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import { getLoadOptionsParams } from "../utils/loadoptions-params";
import euCallSchemeMappingService from "../services/euCallSchemeMapping.service.js";

// A function that takes the server URL as an argument allowing us to use it for different endpoints and returns a new DevExtreme CustomStore instance
// We use this store for DataGrid data sources (so far)
const createCustomStore = (url, additionalFilter, key) => {
  return new CustomStore({
    cacheRawData: false,
    key: key,
    load: async loadOptions => {
      return await axios
        .get(url + getLoadOptionsParams(loadOptions), {
          params: additionalFilter
        })
        .then(response => {
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary
          };
        })
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
    insert: async data => {
      return await axios
        .post(url, data)
        .then(response => ({ data: response.data }))
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    },
    remove: async key => {
      return await axios
        .delete(`${url}/${key}`)
        .then(response => ({ data: response.data }))
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data
              : error.message;
          throw new Error(errorMessage);
        });
    }
  });
};

// CRUD store for the EU call scheme mapping grid, backed by the EuCallSchemeMappings API.
// Kept separate from the remote-operations createCustomStore above; loads all rows once
// (loadMode "raw") and persists each edit through the mapping service.
const createEuCallSchemeMappingStore = () => {
  // Cache of the last loaded rows so updates can send the full object (the grid passes
  // only the changed fields to update()).
  let rowsCache = [];

  return new CustomStore({
    key: "id",
    loadMode: "raw",
    load: async () => {
      const data = await euCallSchemeMappingService.getAll();
      rowsCache = data;
      return data;
    },
    insert: async values =>
      await euCallSchemeMappingService.create({
        callIdentifierPrefix: values.callIdentifierPrefix,
        schemeId: values.schemeId
      }),
    update: async (key, values) => {
      const existing = rowsCache.find(r => r.id === key) || {};
      return await euCallSchemeMappingService.update({
        id: key,
        callIdentifierPrefix:
          values.callIdentifierPrefix ?? existing.callIdentifierPrefix,
        schemeId: values.schemeId ?? existing.schemeId
      });
    },
    remove: async key => {
      await euCallSchemeMappingService.delete(key);
    }
  });
};

export default createCustomStore;
export { createEuCallSchemeMappingStore };
